import { Button } from "@novaescola/eva-react-v2/lib/Button";
import { formatInTimeZone } from 'date-fns-tz';
import Cookies from "js-cookie";
import React, { useEffect, useMemo, useState } from "react";
import ReactGA from "react-ga";
import { Helmet } from "react-helmet";

import { isContentRecomposition } from '../../data/utils';
import NeedHelpDiscrepancy from "../content-page/NeedHelpDiscrepancy";
import ThemeTechnologySubscribe from "../content-page/ThemeTechnologySubscribe";
import AntiracistManifesto from "./AntiracistManifesto";
import { ConfirmationBlock } from "./confirmation-block";
import ThemeFund2Subscribe from "./ThemeFund2Subscribe";

const escapeHtml = (text) => {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
    '\\': '&#92;',
    '\n': '&#10;',
  };
  return text.replace(/[&<>"'\\\n]/g, (m) => map[m]);
}

const escapeText = (text) => {
  if (!text) {
    return "";
  }
  
  return text.replace(/\\/g, "\\").replace(/"/g, '\\"').replace(/'/g, "\\'").replace(/\\n/g, /\\/);
};

const Article = ({ data, loggedIn, userData }) => {
  const { tags } = data.content

  let tagsOfContent = tags.map((e) => e.tag);

  const [showSubscribeThemeTechnology, setShowSubscribeThemeTechnology] = useState(false)
  const [showSubscribeThemeFund2, setShowSubscribeThemeFund2] = useState(false)
  
  React.useEffect(()=>{
    if (tagsOfContent.includes("Tecnologia")) {
      setShowSubscribeThemeTechnology(true);
    } else if (
      tagsOfContent.includes("Anos finais do Fundamental") ||
      tagsOfContent.includes("Adolescência")
    ) {
      setShowSubscribeThemeFund2(true);
    }
  },[])

  const authors = data.content.authors.map(author => {
    return `{"@type":"Person",
      "name":"${author.author}",
      "url": "${author.uri}"}`;
  });

  const isRecomposition = isContentRecomposition(data.content.categories);
  const isLpManifestoAntirracista = data.content.url === "/conteudo/21677/manifesto-por-uma-educacao-antirracista"

  const textContent = data.content.content.replace(/(<([^>]+)>)/gi, "");
  const textWords = textContent.split(" ");

  const downloadButtonProps = useMemo(() => {
    if (!Cookies.get("Bearer"))
      return {
        url: `https://account.novaescola.org.br/auth/signin`,
        complementoCadastroEventLabel:
          "matrícula - Botão baixar no meio do texto - deslogado fez login ou criou conta",
        target: "_self",
      };

    if (Cookies.get("Bearer") && !userData) return;

    const { ocupacao, etapas, disciplinas, raca, enderecos } = userData;
    const dtUltimaModificacao = new Date(userData.dtUltimaModificacao);
    const lastYear = new Date();
    lastYear.setMonth(lastYear.getMonth() - 12);
    const twoMonthsAgo = new Date();
    twoMonthsAgo.setMonth(twoMonthsAgo.getMonth() - 2);

    if (
      ocupacao &&
      etapas &&
      etapas.length > 0 &&
      disciplinas &&
      disciplinas.length > 0
    ) {
      if (dtUltimaModificacao < lastYear) {
        return {
          url: `/complemento-cadastro`,
        };
      }

      if (dtUltimaModificacao > twoMonthsAgo) {
        return {
          complementoCadastroEventLabel:
            "matrícula - Botão baixar no meio do texto - etapa 1 completa",
        };
      }

      if (
        enderecos &&
        enderecos.length > 0 &&
        enderecos[0].cidade &&
        enderecos[0].estado
      ) {
        const complementoCadastroEventLabel = `matrícula - Botão baixar no meio do texto - etapa 2 completa - ${
          raca ? "com" : "sem"
        } raça`;

        return {
          complementoCadastroEventLabel,
        };
      }

      return {
        url: `/complemento-cadastro-2`,
      };
    }

    return {
      url: `/complemento-cadastro`,
    };
  }, [userData]);

  const [urlDownloadComplementaryMaterial, setUrlDownloadComplementaryMaterial] = useState("");

  // logica para implementar data-track nos botões de download de arquivos
  useEffect(() => {
    const parser = new DOMParser();
    const html = parser.parseFromString(data.content.content, "text/html");
    const anchors = html.querySelectorAll("a");
    let anchorsUpdated = false;
    const expires = new Date();
    expires.setTime(expires.getTime() + 3 * 60 * 1000);
    const cookiesOptions = {
      domain: ".novaescola.org.br",
      expires,
      path: "/",
    };
    for (const anchor of anchors) {
      const btnText = anchor.textContent.toLowerCase();

      if (
        btnText.includes("baixe") ||
        btnText.includes("download") ||
        btnText.includes("baixar") ||
        btnText.includes("e-book")
      ) {
        const urlDownload = anchor.getAttribute("href");
        if (!urlDownload.includes("sucesso-download")){
          setUrlDownloadComplementaryMaterial(urlDownload)
        }  
        
        if (downloadButtonProps) {
          anchorsUpdated = true;

          if (
            downloadButtonProps.complementoCadastroEventLabel &&
            !downloadButtonProps.url
          )
            downloadButtonProps.url = urlDownload;

          const handleClick = () => {
            window.dataLayer = window.dataLayer || [];

            let response = "";

            if (downloadButtonProps.complementoCadastroEventLabel)
              response += `window.dataLayer.push({
                event: "cta_click",
                category: "link",
                label: "${downloadButtonProps.complementoCadastroEventLabel}"
              });`;
            else if (!urlDownload.includes("/complemento-cadastro"))
              response += `setCookiesToCompleteRegistrationRedirect("${urlDownload}");`;

            const urlId = data.content.url.split("/")[2];
            const urlDownloadSplitted = urlDownload.split("/");
            let label = `Click - Botão baixar no meio do texto - ${urlId} - ${
              urlDownloadSplitted[urlDownloadSplitted.length - 1].includes(
                ".pdf"
              )
                ? urlDownloadSplitted[urlDownloadSplitted.length - 1]
                : anchor.textContent
            }`;

            //validação feita apenas para esse conteúdo com base na tarefa https://novaescola.atlassian.net/browse/ENTRADA-651
            if (
              data.content.title ===
                "Educação Baseada na Natureza: um caminho para o combate às mudanças climáticas" &&
              data.content.url ===
                "/conteudo/22090/educacao-baseada-na-natureza-boas-praticas"
            ) {
              Cookies.set(
                "ane_download_from_alana_22090_article",
                "TRUE",
                cookiesOptions
              );
              label = `Click: guia Educação Baseada na Natureza - ${
                !Cookies.get("Bearer") ? "deslogado" : "logado"
              }`;
            }

            response += `window.dataLayer.push({
              event: "cta_click",
              category: "link",
              label: "${label}"
            });`;

            return response;
          };

          anchor.setAttribute("onClick", handleClick());

          if (downloadButtonProps.target)
            anchor.setAttribute("target", "_self");

          anchor.setAttribute("href", downloadButtonProps.url);

          if (!urlDownload.includes("/complemento-cadastro")) {
            
            Cookies.set(
              "ane_download_content_url",
              urlDownloadComplementaryMaterial,
              cookiesOptions
            );
            Cookies.set(
              "ane_download_alternative_file_name",
              data.content.title + "-material-complementar.pdf",
              cookiesOptions
            );
            Cookies.set("ane_download_content", "true", cookiesOptions);
            anchor.setAttribute("target", "_self");
            anchor.setAttribute(
              "href",
              "https://novaescola.org.br/sucesso-download"
            );
            if (!Cookies.get("Bearer")) {
              Cookies.set(
                "ane_redirect",
                "https://novaescola.org.br/sucesso-download",
                {
                  domain: ".novaescola.org.br",
                }
              );
              anchor.setAttribute(
                "href",
                "https://account.novaescola.org.br/auth/signin"
              );
            }
          }
        }
      }
    }

    if (anchorsUpdated) {
      let body = html.querySelector("body");
      data.content.content = body.innerHTML;
    }
  }, [data.content.content, userData]);
 
  const continueReadingButtonText = ("continuar lendo");
  const [showOpacity, setShowOpacity] = useState("continue-reading-opacity");
  const [showContent, setShowContent] = useState(false);
  const [showButtonKeepReading, setShowButtonKeepReading] = useState(true);

  const showAllContent = () => {
    setShowOpacity(!showOpacity);
    setShowContent(true)
    setShowButtonKeepReading(false)
  };

  React.useEffect(() => {
    if(data.content.isOpenContent){
      showAllContent()
    }

    const scriptElements = document.querySelectorAll(".content-body script");

    scriptElements.forEach(script => {
      const newScript = document.createElement('script');

      if (script.src) {
        newScript.src = script.src;

        document.body.appendChild(newScript);
        document.body.removeChild(newScript);
      }
    });
  }, [])

  const publishedAt = new Date(data.content?.publishedAt);
  const updatedAt = new Date(data.content?.updatedAt);
  const apiUrl = process.env.GATSBY_ACCOUNT_API_BASE_URL;
  const keepReadingURL = apiUrl + '/auth/signin';

  return (
    <>
      <div className="article">
        {/* <div className={!!loggedIn || showContent ? "show-content" : "hidden-content"}> */}
        <div id="audimaWidget" className="audima eva-margin-bottom-4 eva-margin-top-2"></div>
        
        <div className={showContent ? "show-content" : "hidden-content"}>

          {data.content.url.startsWith('/conteudo') && <ConfirmationBlock />}

          {!showContent && <div className={showOpacity ? "continue-reading-opacity" : null}></div>}
          {/* {!loggedIn && <div className={showOpacity ? "continue-reading-opacity" : null}></div>} */}

          {showSubscribeThemeTechnology && (
            <ThemeTechnologySubscribe loggedIn={loggedIn} setShowSubscribeThemeTechnology={setShowSubscribeThemeTechnology}/>
          )}
          
          {showSubscribeThemeFund2 && (
            <ThemeFund2Subscribe loggedIn={loggedIn} setShowSubscribeThemeFund2={setShowSubscribeThemeFund2}/>
          )}

          <div
            className="content-body eva-body-lora-1 eva-mb-08"
            dangerouslySetInnerHTML={{ __html: data.content.content }}
          ></div>

          {isLpManifestoAntirracista && <AntiracistManifesto />}

          {isRecomposition && <NeedHelpDiscrepancy/>}

        </div>
      </div>

      {/* {!loggedIn && showButtonKeepReading && ( */}
      {showButtonKeepReading && !data.content.isOpenContent && (
          <Button 
            id="keepReading"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 'fit-content'
            }}  
            className="paywall eva-margin-center eva-margin-bottom-1"
            size="medium"
            data-track="SITE: Click - Nova página de conteúdo - botão continuar lendo"
            onClick={() => {
              showAllContent()
              ReactGA.event({
                action: "Click",
                category: "SITE",
                label: "Nova página de conteúdo - botão continuar lendo",
              });
            }}  
          >
            {continueReadingButtonText}
          </Button>
        )
      }
       {!loggedIn && showButtonKeepReading && (
        <>
          {/* {data.content.isOpenContent ?
            <Button 
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 'fit-content'
              }}
              size="medium"
              data-track="SITE: Click - Nova página de conteúdo - botão continuar lendo"
              onClick={() => {
                showAllContent()
                ReactGA.event({
                  action: "Click",
                  category: "SITE",
                  label: "Nova página de conteúdo - botão continuar lendo",
                });
              }}  
            >
              {continueReadingButtonText}
            </Button>
            :
            <Button 
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 'fit-content'
              }}  
              size="medium" 
              asChild
            >
              <a href={keepReadingURL}
                type="button" 
                className="paywall eva-margin-center"
                data-track="Nova página de conteúdo - botão continuar lendo"
                onClick={() => {
                  ReactGA.event({
                    action: "Click",
                    category: "SITE",
                    label: "Nova página de conteúdo - botão continuar lendo",
                  });
                }} 
              >
                {continueReadingButtonText}
              </a>
            </Button>
          } */}

          <Helmet>
            <script type="application/ld+json">
              {`{
                  "@context":"https://schema.org",
                  "@graph":[
                     {
                      "@type":"Organization",
                      "@id":"Nova Escola | Conteúdos alinhados à BNCC",
                      "name":"Nova Escola",
                      "url":"https://novaescola.org.br/",
                      "sameAs":[
                          "Nova Escola",
                          "novaescola",
                          "https://www.linkedin.com/company/associa%C3%A7%C3%A3o-nova-escola/",
                          "NOVA ESCOLA",
                          "https://www.instagram.com/novaescola/"
                      ]
                     },
                     {
                      "@type":"WebSite",
                      "@id":"Jornalismo Nova Escola | Home",
                      "url":"https://novaescola.org.br/subhome/176/jornalismo",
                      "name":"Jornalismo Nova Escola | Home"
                     },
                     {
                      "@type":"WebPage",
                      "@id":"${escapeText(data.content.title)}",
                      "url":"https://novaescola.org.br${data.content.url}",
                      "inLanguage":"pt-BR",
                      "name":"${escapeText(data.content.title)}",
                      "isAccessibleForFree":"False",
                      "hasPart":{
                        "@type":"WebPageElement",
                        "isAccessibleForFree":"False",
                        "cssSelector":".hidden-content"
                      },
                      "description":"${escapeText(data.content.seoDescription)}",
                      "isPartOf":{
                        "@id":"Jornalismo Nova Escola | Home"
                      },
                      "about":{
                        "@id":"Nova Escola | Conteúdos alinhados à BNCC"
                      }
                     }
                  ]
              }`}
            </script>
          </Helmet>
        </>
      )} 

      <Helmet>
        <script type="application/ld+json">
          {`{
            "@context":"https://schema.org/",
            "@type":"Article",
            "mainEntityOfPage":" https://novaescola.org.br${escapeText(data.content.url)}",
            "headline":"${escapeText(data.content.title)}",
            "datePublished":"${formatInTimeZone(publishedAt,'America/New_York', 'yyyy-MM-dd hh:mm:ss')}",
            "publisher":{"@type":"Organization",
            "name":"Nova Escola"},
            "description":"${escapeText(data.content.seoDescription)}",
            "articleBody":"${escapeHtml(data.content.content)}",
            "dateModified":"${data.content.updatedAt ? formatInTimeZone(updatedAt,'America/New_York', 'yyyy-MM-dd hh:mm:ss') :  formatInTimeZone(publishedAt, 'America/New_York', 'yyyy-MM-dd hh:mm:ss')}",
            "image":{"@type":"ImageObject",
            "url":"${data.content.thumbnailImage || data.content.featuredImage}",
            "height":"1280",
            "width":"853"},
            "author":"[${escapeText(authors.toString())}]",
            "wordcount":${textWords.length}
          }`}
        </script> 
      </Helmet>
    </>
  );
};
export default Article;